import { useTranslation } from 'react-i18next';
import { InfoLabel } from '../Badges/InfoLabel';
import { ButtonSize } from '../Fundamentals/Button';
import SkynetIconButton from '../Fundamentals/IconButton/SkynetIconButton';
import WithTooltip from '../Fundamentals/Tooltip/WithTooltip';

interface WorksheetKeepPriceSlotProps {
    isKept: boolean;
    onToggle?: () => void;
}

const WorksheetKeepPriceSlot = ({ isKept, onToggle }: WorksheetKeepPriceSlotProps) => {
    const { t } = useTranslation();
    const canToggle = onToggle !== undefined;
    const label = t('priceSimulation.keepPrice') ?? '';

    return (
        <div className="d-flex align-items-center gap-8">
            <span className={isKept ? undefined : 'invisible'} aria-hidden={!isKept}>
                <InfoLabel type="secondary" title={t('priceSimulation.kept')} />
            </span>
            {canToggle ? (
                <WithTooltip content={label} className="d-inline-flex">
                    <SkynetIconButton icon="success" filled={isKept} active={isKept} size={ButtonSize.SMALL} label={label} title="" onClick={onToggle} />
                </WithTooltip>
            ) : (
                <SkynetIconButton icon="success" size={ButtonSize.SMALL} label={label} disabled className="invisible" />
            )}
        </div>
    );
};

export default WorksheetKeepPriceSlot;
